module.exports = __webpack_public_path__ + "img/inspire-banner.f58ce0c1.webp";